/* eslint-disable no-void */
/* eslint-disable default-param-last */
/* eslint-disable camelcase */
/**
 * Tracking próprio (pipeline SQS) — fire-and-forget e à prova de falha.
 *
 * Por que NÃO usa o axios global (services/api):
 *   o `Api` tem interceptors que deslogam o usuário em 403/423. Um erro de
 *   tracking jamais pode disparar isso, então aqui usamos `fetch` isolado.
 *
 * Garantias:
 *   - não bloqueia a UI (sem await), sobrevive à navegação (keepalive);
 *   - nunca lança — qualquer erro é engolido;
 *   - pode ser desligado na hora com REACT_APP_TRACKING_ENABLED=false.
 *
 * `event_name` segue o catálogo (ex.: 'edital.baixou'); o `controle` do cliente
 * é resolvido no backend pela sessão, não enviado pelo front.
 */

const ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT || ''}/api/events`;
const ENABLED = process.env.REACT_APP_TRACKING_ENABLED !== 'false';

// Dedup defensivo: colapsa eventos IDÊNTICOS disparados em rajada (ex.: useEffect
// refazendo em milissegundos, re-render, duplo-bind). Janela curta de propósito —
// repetições espaçadas legítimas (ex.: duas buscas com segundos de intervalo) NÃO
// são afetadas. O event_id é cunhado no backend por requisição, então a deduplicação
// por event_id não pega esses casos; barramos aqui, na origem.
const DEDUP_WINDOW_MS = 1500;
const lastSentAt = new Map<string, number>();

export function track(
  event_name: string,
  properties: Record<string, unknown> = {},
  label?: string,
  dedupSeed?: string,
): void {
  if (!ENABLED || !event_name) return;

  try {
    // dedup_seed (opcional): semente determinística da ocorrência lógica. O backend
    // deriva um event_id estável (UUIDv5) a partir dela, deduplicando ponta a ponta
    // (multi-aba/refresh/remount) via o INSERT IGNORE do consumidor. Quem não passa
    // dedupSeed mantém o comportamento atual (event_id aleatório no backend).
    const body = JSON.stringify({ event_name, label, properties, dedup_seed: dedupSeed });

    const now = Date.now();
    const prev = lastSentAt.get(body);
    if (prev !== undefined && now - prev < DEDUP_WINDOW_MS) return;
    if (lastSentAt.size > 500) lastSentAt.clear(); // limite simples p/ não crescer sem fim
    lastSentAt.set(body, now);

    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', frontend: 'true' },
      body,
      credentials: 'include',
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* tracking nunca pode quebrar a UI — erros são engolidos de propósito */
  }
}

export default track;
